import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { SVGIconComponent } from '@progress/kendo-angular-icons';

@Component({
    selector: 'app-primary-button',
    templateUrl: './primary-button.component.html',
    styleUrls: ['./primary-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, SVGIconComponent],
})
export class PrimaryButtonComponent {
  @Input() type: 'button' | 'submit' = 'button';
  @Input() disabled = false;
  @Input() icon?: SVGIcon;
  @Input() iconPosition: 'left' | 'right' = 'left';

  onClick(event: Event): void {
    // Don't stop propagation - let the parent component handle the click
    // Only prevent if disabled
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
